import React, { useEffect, useState } from 'react';
import { Captcha as CaptchaBase } from '@zooplus/captcha-lib-react/dist/cjs';
import { ContactFormConnector } from '../../../services/connectors/ContactFormConnector';
import { CaptchaConfigurationRequest } from '../../../services/connectors/CaptchaConfigurationRequest';

const Captcha: React.FC<CaptchaProps> = (props: CaptchaProps) => {
  const contactFormConnector = new ContactFormConnector();
  const [enabled, setEnabled] = useState(false);
  const [providerName, setProviderName] = useState('');
  const [siteKey, setSiteKey] = useState('');

  useEffect(() => {
    const request = new CaptchaConfigurationRequest(props.domain, props.preferredCaptcha);
    contactFormConnector
      .requestCaptchaConfiguration(request)
      .then(({ enabled, providerName, siteKey }) => {
        setEnabled(enabled);
        setProviderName(providerName);
        setSiteKey(siteKey);
        if (enabled) {
          props.onEnabled?.();
        }
      });
  }, []);

  return (
    <div>
      {enabled && (
        <CaptchaBase
          providerName={providerName}
          siteKey={siteKey}
          language={props.language}
          onVerified={props.onVerified}
        />
      )}
    </div>
  );
};

export default Captcha;

export interface CaptchaProps {
  domain: string;
  language: string;
  preferredCaptcha?: string;
  onVerified?: () => any;
  onEnabled?: () => any;
}
